module.exports = __webpack_public_path__ + "static/media/product-summary-1.fbc6eff5.jpg";